import { Text } from "react-native";
import { useTranslation } from "react-i18next";

import { helpTextStyle } from "../primitives/helpTextStyle";
import type { UiTheme } from "../theme";

// The one line a chart shows when its data was cut at a load cap: older
// points exist but are not drawn (no count, so no plural forms).
export function ChartCappedNote({ theme }: { theme: UiTheme }) {
  const { t } = useTranslation();
  return (
    <Text style={helpTextStyle(theme)}>
      {t("progress.chartCapped", {
        defaultValue:
          "Only the most recent data is shown. Older data is not in this chart.",
      })}
    </Text>
  );
}
